import React from 'react'
import AnalyticsChart from '../layout/AnalyticsChart'
import getAgeChartOptions from '../charts/ageChart'
import { type IAnalyticsModuleProps } from '../../../../interfaces/store/analyticsStore.interface'
import { Box } from '@mui/material'

export default function Age (props: IAnalyticsModuleProps): JSX.Element {
  const containerId = 'ax-age-chart'
  return (
    <Box className={`ax-chart-container ${containerId}`}>
      <AnalyticsChart
        containerId={containerId}
        chartOptions={getAgeChartOptions(props.users, props.analyticsActions)}
      />
    </Box>
  )
}
